/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePrinterJpkDocumentDto
 */
export interface CreatePrinterJpkDocumentDto {
    /**
     * 
     * @type {number}
     * @memberof CreatePrinterJpkDocumentDto
     */
    jpkId?: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePrinterJpkDocumentDto
     */
    printerUid?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePrinterJpkDocumentDto
     */
    documentType?: CreatePrinterJpkDocumentDtoDocumentTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof CreatePrinterJpkDocumentDto
     */
    jpkData?: object;
    /**
     * 
     * @type {string}
     * @memberof CreatePrinterJpkDocumentDto
     */
    binaryData?: string;
}


/**
 * @export
 */
export const CreatePrinterJpkDocumentDtoDocumentTypeEnum = {
    Paragon: 'Paragon',
    Raport: 'Raport',
    Inne: 'Inne'
} as const;
export type CreatePrinterJpkDocumentDtoDocumentTypeEnum = typeof CreatePrinterJpkDocumentDtoDocumentTypeEnum[keyof typeof CreatePrinterJpkDocumentDtoDocumentTypeEnum];


/**
 * Check if a given object implements the CreatePrinterJpkDocumentDto interface.
 */
export function instanceOfCreatePrinterJpkDocumentDto(value: object): value is CreatePrinterJpkDocumentDto {
    return true;
}

export function CreatePrinterJpkDocumentDtoFromJSON(json: any): CreatePrinterJpkDocumentDto {
    return CreatePrinterJpkDocumentDtoFromJSONTyped(json, false);
}

export function CreatePrinterJpkDocumentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePrinterJpkDocumentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'jpkId': json['jpkId'] == null ? undefined : json['jpkId'],
        'printerUid': json['printerUid'] == null ? undefined : json['printerUid'],
        'documentType': json['documentType'] == null ? undefined : json['documentType'],
        'jpkData': json['jpkData'] == null ? undefined : json['jpkData'],
        'binaryData': json['binaryData'] == null ? undefined : json['binaryData'],
    };
}

export function CreatePrinterJpkDocumentDtoToJSON(value?: CreatePrinterJpkDocumentDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'jpkId': value['jpkId'],
        'printerUid': value['printerUid'],
        'documentType': value['documentType'],
        'jpkData': value['jpkData'],
        'binaryData': value['binaryData'],
    };
}

